import { useState } from "react";

import AlertMessage from "./AlertMessage";

export type AlertHook = {
	alert: AlertMessage | null;

	clear: () => void;
	success: (message: string) => void;
	warning: (message: string) => void;
	error: (message: string) => void;
	info: (message: string) => void;
};

export default function useAlert(): AlertHook {
	const [alert, setAlert] = useState<AlertMessage | null>(null);

	function clear() {
		setAlert(null);
	}

	function success(message: string) {
		setAlert(AlertMessage.success(message));
	}

	function warning(message: string) {
		setAlert(AlertMessage.warning(message));
	}

	function error(message: string) {
		setAlert(AlertMessage.error(message));
	}

	function info(message: string) {
		setAlert(AlertMessage.info(message));
	}

	return { alert, clear, success, warning, error, info };
}
